<template>
  <div>
    <el-row class="search-add" :gutter="10">
      <el-col :span="4">
        <el-input placeholder="公司名称" v-model="searchForm.companyName" clearable></el-input>
      </el-col>
      <el-col :span="4">
        <el-input placeholder="联系人" v-model="searchForm.contactName" clearable></el-input>
      </el-col>
      <el-col :span="4">
        <el-input placeholder="联系电话" v-model="searchForm.contactPhone" clearable></el-input>
      </el-col>
      <el-col :span="12">
        <el-button type="primary" icon="el-icon-search" @click="search">搜索</el-button>
        <el-button type="success" icon="el-icon-plus" @click="handleAdd">新增公司</el-button>
      </el-col>
    </el-row>

    <el-table :data="tableData" border stripe style="width: 100%">
      <el-table-column prop="name" label="公司名称" width="200"></el-table-column>
      <el-table-column prop="short_name" label="简称" width="150"></el-table-column>
      <el-table-column prop="owner" label="负责人" width="120"></el-table-column>
      <el-table-column prop="mobile" label="联系电话" width="130"></el-table-column>
      <el-table-column prop="email" label="邮箱" width="180"></el-table-column>
      <el-table-column prop="address" label="地址" min-width="200"></el-table-column>
      <el-table-column prop="uscc" label="社会信用代码" width="180"></el-table-column>
      <el-table-column prop="usccFile" label="营业执照" width="100">
        <template slot-scope="scope">
          <el-button
            v-show="scope.row.usccFile"
            @click="handlePreview(scope.row.usccFile)"
            type="text"
            size="small"
          >预览</el-button>
        </template>
      </el-table-column>
      <el-table-column fixed="right" label="操作" width="150">
        <template slot-scope="scope">
          <el-button type="text" size="small" @click="handleEdit(scope.row)">编辑</el-button>
          <el-button type="text" size="small" style="color: #f56c6c" @click="handleDelete(scope.row)">删除</el-button>
        </template>
      </el-table-column>
    </el-table>

    <el-dialog :visible.sync="dialogVisible" width="90%">
      <template>
        <iframe
          :src="dialogImageUrl"
          style="width: 100%; height: 600px; border: none"
        ></iframe>
      </template>
    </el-dialog>

    <div class="tableDel-Page">
      <Pagination :params="pagin" @pageBind="getList"></Pagination>
    </div>
  </div>
</template>

<script>
import Pagination from '@/components/Pagination';

export default {
  name: 'CompanyList',
  components: {
    Pagination
  },
  data() {
    return {
      searchForm: {
        companyName: '',
        contactName: '',
        contactPhone: ''
      },
      tableData: [],
      pagin: {
        total: 0,
        pageSize: 10,
        pageNum: 1
      },
      dialogVisible: false,
      dialogImageUrl: ''
    };
  },
  mounted() {
    this.getList();
  },
  methods: {
    // 获取列表数据
    getList() {
      const params = {
        pageNum: this.pagin.pageNum,
        pageSize: this.pagin.pageSize
      };
      
      if (this.searchForm.companyName && this.searchForm.companyName.trim()) {
        params.name = this.searchForm.companyName;
      }
      if (this.searchForm.contactPhone && this.searchForm.contactPhone.trim()) {
        params.mobile = this.searchForm.contactPhone;
      }
      
      this.$http.post('/manage/institution/list', params)
        .then(res => {
          if (res.data.code === 0) {
            this.tableData = res.data.data.records || [];
            this.pagin.total = res.data.data.total || 0;
          } else {
            this.$message.error(res.data.message || '获取数据失败');
          }
        })
        .catch(err => {
          this.$message.error('网络请求失败');
          console.error(err);
        });
    },
    
    // 搜索
    search() {
      this.pagin.pageNum = 1;
      this.getList();
    },
    
    // 新增公司
    handleAdd() {
      this.$store.commit('setEditInfo', {
        id: 0,
        name: '',
        short_name: '',
        owner: '',
        mobile: '',
        email: '',
        address: '',
        uscc: '',
        usccFile: '',
        file: null
      });
      this.$router.push('/install/company/edit');
    },
    
    // 编辑公司
    handleEdit(row) {
      this.$store.commit('setEditInfo', row);
      this.$router.push({
        path: '/install/company/edit',
        query: { id: row.id }
      });
    },
    
    // 删除公司
    handleDelete(row) {
      this.$confirm('确定删除该安装公司吗？', '提示', {
        confirmButtonText: '确定',
        cancelButtonText: '取消',
        type: 'warning'
      }).then(() => {
        this.$http.post('/manage/institution/del', { id: row.id })
          .then(res => {
            if (res.data.code === 0) {
              this.$message.success('删除成功');
              this.getList();
            } else {
              this.$message.error(res.data.message || '删除失败');
            }
          })
          .catch(err => {
            this.$message.error('删除失败');
            console.error(err);
          });
      }).catch(() => {});
    },
    
    // 预览营业执照
    handlePreview(url) {
      console.log(url);
      this.dialogImageUrl = url;
      this.dialogVisible = true;
    }
  }
};
</script>

<style scoped>
.search-add {
  margin-bottom: 20px;
}
.tableDel-Page {
  margin-top: 20px;
}
</style>

